
export const getNearbyBuses = (signal: any, lat: number, lng: number) => {
    if (lat === undefined || lng === undefined) {
        lng = -2.7842062;
        lat = 54.0064025;
    }

    return fetch(
        `https://ilancasterapi.lancaster.ac.uk/transport/api/v1/BusStops?latitude=${lat}&longitude=${lng}&token=a669a058-4284-4eb0-9f14-36e717ed04d8`,
        {
            signal,
            headers: new Headers({
                "content-type": "application/json",
                accept: "application/json",
            }),
        }
    )
        .then((res) => {
            if (res.ok) {
                return res.json();
            } else {
                return [];
            }
        })
        .then((json) => json)
        .catch(err => {
            if (err.name !== 'AbortError') {
                console.error('Uh oh, an error!', err);
            }
        });
};

export const getPcs = (signal: any) => {
    return fetch(
        `https://ilancasterapi.lancaster.ac.uk/timetable/api/AvailableComputers/getPcInfo`,
        {
            signal,
            headers: new Headers({
                "content-type": "application/json",
                accept: "application/json",
            }),
        }
    )
        .then((res) => {
            if (res.ok) {
                return res.json();
            } else {
                return null;
            }
        })
        .then((json) => json);
};

export const getLaundry = (signal: any) => {
    return fetch(
        `https://ilancasterapi.lancaster.ac.uk/production/api/v1/Laundrette/school/available`,
        {
            signal,
            headers: new Headers({
                "content-type": "application/json",
                accept: "application/json",
            }),
        }
    )
        .then((res) => {
            if (res.ok) {
                return res.json();
            } else {
                return null;
            }
        })
        .then((json) => json);
};

export const getOutlets = (signal: any) => {
    return fetch(
        `https://www.e-res.lancaster.ac.uk/DirectoryWebAPI/api/v2/Business/All/`,
        {
            signal,
            headers: new Headers({
                "content-type": "application/json",
                accept: "application/json",
            }),
        }
    )
        .then((res) => {
            if (res.ok) {
                return res.json();
            } else {
                return null;
            }
        })
        .then((json) => json);
};

export const getBusTimetable = (signal: any, atcoCode: string) => {
    return fetch(
        `https://ilancasterapi.lancaster.ac.uk/transport/api/v1/BusStops/${atcoCode}/next?token=a669a058-4284-4eb0-9f14-36e717ed04d8`,
        {
            signal,
            headers: new Headers({
                "content-type": "application/json",
                accept: "application/json",
            }),
        }
    )
        .then((res) => {
            if (res.ok) {
                return res.json();
            } else {
                return null;
            }
        })
        .then((json) => json);
};
